import type { ProductAnalyticsEvent, ProductEventFields, ProductEventName } from "./eventTypes";

const ARTIFACT_SHA = /^[0-9a-f]{64}$/;

type FactoryOptions = {
  artifactSha: string;
  now?: () => Date;
  uuid?: () => `${string}-${string}-${string}-${string}-${string}`;
};

export function createProductAnalyticsEvent<E extends ProductEventName>(
  event: E,
  fields: ProductEventFields<E>,
  options: FactoryOptions,
): Extract<ProductAnalyticsEvent, { event: E }> {
  if (!ARTIFACT_SHA.test(options.artifactSha)) throw new Error("A 64-character artifact SHA is required");
  return {
    event,
    clientEventId: (options.uuid ?? (() => crypto.randomUUID()))(),
    occurredAt: (options.now ?? (() => new Date()))().toISOString(),
    host: "app",
    artifactSha: options.artifactSha,
    ...fields,
  } as Extract<ProductAnalyticsEvent, { event: E }>;
}
